document.addEventListener("DOMContentLoaded", function () {
  // Add a click event listener to the close button
  closePopup.addEventListener("click", function () {
    // Pause the video and hide the popup
    popupVideo.pause();
    videoPopup.style.display = "none";
  });
});
function playVid(videoId) {
  let str = videoId;
  str = str.substring(1);
  var video = $("#" + str);
  // Detect play/pause state of video and toggle
  if (video.get(0).paused) {
    video.get(0).play();
  } else {
    video.get(0).pause();
  }
  $("#" + videoId)
    .find("svg")
    .toggle("hideDiv");
  const videoLink = this.getAttribute("data-video");
  alert(videoLink);
  // Set the video source and show the popup
  popupVideo.src = videoLink;
  videoPopup.style.display = "block";
}
